module.exports = __webpack_public_path__ + "img/error-img.3acc8800.png";